import store from '@/store';

const currentRole = async () => {
  const role = await store.getters['auth/currentUserRoleInfo'];
  return (role && role === 'mro_manage_supplier');
};

export default [
  {
    path: '/catalog',
    name: 'catalog',
    redirect: {
      name: 'catalog.search',
    },
    component: {
      render(c) {
        return c('router-view');
      },
    },
    meta: {
      breadcrumb: 'Catalog',
      menuOptions: {
        title: 'Catalog',
        description: 'En esta sección podrá realizar búsquedas específicas sobre su catálogo de ítems',
      },
    },
    children: [
      {
        path: 'search',
        name: 'catalog.search',
        component: () => import('@/pages/supplier/catalog/search'),
        meta: {
          breadcrumb: 'Search',
          menuOptions: {
            title: 'Search',
            description: 'En esta sección podrá realizar búsquedas específicas sobre su catálogo de ítems',
          },
        },
      },
      {
        path: ':item',
        name: 'catalog.products.item',
        component: () => import('@/pages/supplier/catalog/product'),
        meta: {
          breadcrumb() {
            const storeInfo = this.$store.getters['catalog/currentProductItemInfo'];
            if (!storeInfo) {
              return 'Item';
            }

            return `Item - ${storeInfo.name}`;
          },
        },
      },
      {
        path: 'report',
        name: 'report',
        redirect: {
          name: 'report.match',
        },
        component: {
          render(c) {
            return c('router-view');
          },
        },
        meta: {
          breadcrumb: 'Reports',
          menuOptions: {
            title: 'supplier-admin',
            description: 'En esta sección podrá conocer información sobre tus ítems',
          },
        },
        children: [
          {
            path: 'match',
            name: 'report.match',
            component: () => import('@/pages/supplier/reports/match'),
            meta: {
              breadcrumb: 'Actividad en búsqueda',
              menuOptions: {
                title: 'supplier-admin',
                description: 'En esta sección podrá ver su actividad',
              },
            },
          },
        ],
      },
      {
        path: 'admin',
        name: 'supplier-admin',
        redirect: { name: 'supplier-admin.manage-products' },
        meta: {
          breadcrumb: 'Administrator',
          menuOptions: {
            title: 'Administration',
          },
        },
        component: {
          render(c) { return c('router-view'); },
        },
        children: [
          {
            path: 'products',
            name: 'supplier-admin.manage-products',
            redirect: { name: 'supplier-admin.manage-products.search' },
            meta: {
              breadcrumb: 'Items',
              menuOptions: {
                title: 'Items',
                description: 'En esta sección podrá editar o eliminar sus ítem',
              },
            },
            component: {
              render(c) { return c('router-view'); },
            },
            children: [
              {
                path: 'search',
                name: 'supplier-admin.manage-products.search',
                meta: {
                  breadcrumb: 'Search',
                  welcomeAlert: '',
                },
                component: async () => {
                  const hasPermission = await currentRole();
                  return hasPermission ? import('@/pages/supplier/_admin/manage_products') : null;
                },
              },
              {
                path: 'create-product/:catalog',
                name: 'supplier-admin.create-product',
                meta: {
                  breadcrumb() {
                    const storeInfo = this.$store.getters['catalog/currentProductItemInfo'];
                    if (!storeInfo) {
                      return 'Item';
                    }
                    return 'Nuevo Item';
                  },
                },
                component: async () => {
                  const hasPermission = await currentRole();
                  return hasPermission ? import('@/pages/supplier/_admin/create_product') : null;
                },
              },
              {
                path: 'product/:product',
                name: 'supplier-admin.manage-product',
                meta: {
                  breadcrumb() {
                    const storeInfo = this.$store.getters['catalog/currentProductItemInfo'];
                    if (!storeInfo) {
                      return 'Item';
                    }
                    return `Item - ${storeInfo.name}`;
                  },
                },
                component: async () => {
                  const hasPermission = await currentRole();
                  return hasPermission ? import('@/pages/supplier/_admin/manage_product') : null;
                },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '/request-information',
    name: 'request-information',
    redirect: { name: 'request-information.search' },
    component: {
      render(c) { return c('router-view'); },
    },
    meta: {
      breadcrumb: 'Request for Information',
      menuOptions: {
        title: 'Request for Information',
        description: 'En esta sección podrá reponder a consultas sobre tus ítems',
      },
    },
    children: [
      {
        path: 'search',
        name: 'request-information.search',
        component: () => import('@/pages/supplier/request_information/search'),
        meta: {
          breadcrumb: 'Search',
        },
      },
      {
        path: ':request/request',
        name: 'request-information.request',
        props: route => ({
          requestId: route.params.request,
        }),
        component: () => import('@/pages/supplier/request_information/request'),
        meta: {
          breadcrumb: 'Request for Information',
        },
      },
    ],
  },
  {
    path: '/organization/:slug/profile',
    name: 'organization',
    component: () => import('@/pages/supplier/organization/public-profile'),
    meta: {
      breadcrumb: 'Supplier Profile',
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/routes/supplier.js